export default __webpack_public_path__ + "static/media/Search.f25d915c.svg";